var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tbody',_vm._l((_vm.rowsSync),function(x){return _c('tr',{key:x},[_c('td',{attrs:{"colspan":_vm.colspanSync}})])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }